import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { EPostsActions, GetLinkedPostFailure, GetLinkedPostsData, GetLinkedPostSuccess, GetPostFailure, GetPostsData, GetPostSuccess } from '../actions/posts.actions';
import { PostService } from '@eview/core/domain/post/post.service';

@Injectable()
export class PostEffects {
  constructor(private postService: PostService) {}

  private readonly actions$ = inject(Actions);

  getPosts$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetPostsData>(EPostsActions.GetPostsData),
      map(action => action.payload),
      switchMap(payload =>
        this.postService.list(payload).pipe(
          map(result => new GetPostSuccess(result)),
          catchError(() => of(new GetPostFailure()))
        )
      )
    )
  );

  getLinkedPosts$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetLinkedPostsData>(EPostsActions.GetLinkedPostsData),
      map(action => action.payload),
      switchMap(payload =>
        this.postService.linkedReports(payload).pipe(
          map(result => new GetLinkedPostSuccess(result)),
          catchError(() => of(new GetLinkedPostFailure()))
        )
      )
    )
  );
}
